import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useRemittanceEmailPreview() {
  const mutation = useMutation(
    orpc.finance.payments.previewRemittanceEmail.mutationOptions(),
  );

  return {
    preview: mutation.mutateAsync,
    isPreviewing: mutation.isPending,
    previewData: mutation.data ?? null,
    previewError: mutation.error,
    reset: mutation.reset,
  };
}
